module.exports = __webpack_public_path__ + "static/img/erweima.fa6e604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/erweima.png
// module id = va06
// module chunks = 1